class RedirectToLoginException extends Error {
    constructor(msg: string) {
        super(msg);
        Object.setPrototypeOf(this, RedirectToLoginException.prototype);
    }
}

export default RedirectToLoginException
